/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class UserPasswordChangeDtoModel {

  uuid: string | null = null;

  oldPassword: string | null = null;

  newPassword: string | null = null;

  confirmPassword: string | null = null;

}
